import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../../lib/apiClient';
import { approvalWorkflowsFeatureSelector } from '../../../../pricing/selectors';

export const useShowWorkflowActivity = (annotationId: number | undefined) => {
  const isWorkflowsEnabled = useSelector(approvalWorkflowsFeatureSelector);

  const query = useQuery({
    queryKey: ['showWorkflowActivity', annotationId],

    queryFn: () =>
      api.request(
        endpoints.workflowRuns.list({
          annotation: annotationId,
        })
      ),

    enabled: !!annotationId && isWorkflowsEnabled,
  });

  return query.data && query.data.pagination.total > 0;
};
